import { uploadFileWithPresign } from '@/shared/api/services/upload-service'
import { ACCEPTED_IMAGE_TYPES, MAX_IMAGE_SIZE_MB } from '@/shared/constants'
import { getFileValidationError } from '@/shared/utils/file-validation-utils'

interface UploadImageWithValidationParams {
  file: File
  acceptedTypes?: string[] | readonly string[]
  maxSizeMB?: number
}

export async function uploadImageWithValidation({
  file,
  acceptedTypes = ACCEPTED_IMAGE_TYPES,
  maxSizeMB = MAX_IMAGE_SIZE_MB,
}: UploadImageWithValidationParams) {
  const validationError = getFileValidationError(file, {
    acceptedTypes,
    maxSizeMB,
    kind: 'image',
  })

  if (validationError) {
    throw new Error(validationError)
  }

  return uploadFileWithPresign(file)
}
